import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthAction from "../stores/actions/authAction";
import {
  LOGO,
  INDIAN_MSME_USER_TOKEN,
  INDIAN_MSME_USER_TYPE,
} from "../utils/Constants";
import { toast } from "react-toastify";
import { getCookie, storeCookie } from "../utils/CookieAction";
import { RootState } from "../stores";
import profileAction from "../stores/actions/profileAction";

const NavHeader = ({ setMobileToggle, activeMenu, setActiveMenu }: any) => {
  const dispatch = useDispatch()<any>;

  const page = useNavigate();
  const { profileDetails } = useSelector((state: RootState) => state.auth);
  const logoutHandle = async () => {
    try {
      const tokens: any = getCookie(INDIAN_MSME_USER_TOKEN);
      await dispatch(AuthAction.signOUt({ tokens }));

      localStorage.removeItem("activeMenu");
      localStorage.removeItem("activeSubmenu");
      setActiveMenu(null);

      page("/", { replace: true });
      toast.success("Logout Successfully");
    } catch (e) {}
  };

  const handleUserAccount = (type: string) => {
    storeCookie(INDIAN_MSME_USER_TYPE, JSON.stringify(type));
    dispatch(profileAction.changeUserType({ type }));
  };

  return (
    <>
      <nav
        className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center  bg-green border-shadow-bootom-green"
        id="layout-navbar">
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0   d-xl-none ">
          <a
            className="nav-item nav-link px-0 me-xl-4"
            onClick={() => setMobileToggle("on")}>
            <i className="bx bx-menu bx-sm"></i>
          </a>
        </div>
        <div
          className="navbar-nav-right d-flex align-items-center"
          id="navbar-collapse">
          <div className="flex-row align-items-center ms-auto ">
            <h4 className="text-white mt-3 mb-1 text-center">BUYER PANEL</h4>
            <h5 className="text-white text-center">
              ( {profileDetails?.name_of_entity}-{profileDetails?.account_id} )
            </h5>
          </div>
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <a className="dropdown-item" href="#">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar avatar-online">
                        <img
                          src={LOGO}
                          alt={"Logo"}
                          className="w-px-40 h-auto rounded-circle"
                        />
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <span className="fw-medium d-block text-uppercase">
                        {profileDetails?.name_of_entity}
                      </span>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <div className="dropdown-divider"></div>
              </li>
              <li>
                <Link className="dropdown-item" to="/profile">
                  <i className="bx bx-user me-2"></i>
                  <span className="align-middle">My Profile</span>
                </Link>
              </li>
              <li>
                <div className="dropdown-divider"></div>
              </li>
              <li>
                <div className="dropdown-item" onClick={() => logoutHandle()}>
                  <i className="bx bx-power-off me-2"></i>
                  <span className="align-middle">Log Out</span>
                </div>
              </li>
            </ul>

            <li className="nav-item dropdown-language dropdown me-2 me-xl-0">
              <Link
                to="https://indianmsme.org/"
                className="nav-link dropdown-toggle hide-arrow"
                target="_blank">
                <i className="bx bx-globe bx-sm"></i>
              </Link>
            </li>

            <li className="nav-item navbar-dropdown dropdown-user dropdown">
              <a
                className="nav-link dropdown-toggle hide-arrow"
                href="javascript:void(0);"
                data-bs-toggle="dropdown">
                <div className="avatar avatar-online">
                  <img
                    src={LOGO}
                    alt={"Logo"}
                    className="w-px-40 h-auto rounded-circle"
                  />
                </div>
              </a>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a className="dropdown-item" href="#">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar avatar-online">
                          <img
                            src={LOGO}
                            alt={"Logo"}
                            className="w-px-40 h-auto rounded-circle"
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <span className="fw-medium d-block text-uppercase">
                          {profileDetails?.name_of_entity}
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <Link className="dropdown-item" to="/profile">
                    <i className="bx bx-user me-2"></i>
                    <span className="align-middle">My Profile</span>
                  </Link>
                </li>

                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <div className="dropdown-item" onClick={() => logoutHandle()}>
                    <i className="bx bx-power-off me-2"></i>
                    <span className="align-middle">Log Out</span>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="navbar-search-wrapper search-input-wrapper  d-none">
          <input
            type="text"
            className="form-control search-input container-xxl border-0"
            placeholder="Search..."
            aria-label="Search..."
          />
          <i className="bx bx-x bx-sm search-toggler cursor-pointer"></i>
        </div>
      </nav>
    </>
  );
};

export default NavHeader;
